export function generateOrUpdateCueAreas(cues, prop) {
  let result = cues.reduce((mem, x) => {
    // eslint-disable-next-line no-param-reassign
    if (!mem[x[prop]]) mem[x[prop]] = [];
    mem[x[prop]].push(x)
    return mem
  }, {})
  result = Object.values(result);
  result.sort(( a, b ) => {
    a.sort(( c, d ) => c.number - d.number);
    b.sort(( c, d ) => c.number - d.number);
    const res = a[0].area - b[0].area;
    if (res > 0) return 1
    if (res < 0) return -1
    return 0
  })
  return { count: result.length, result }
}

export function defaultAssessment(participantId, competencyId, observerId, modified) {
  return {
    participantId,
    competencyExerciseId: competencyId,
    observerTeamMemberId: observerId,
    modified: modified || true,
    selectedValue: null,
    selectedCuesIds: []
  }
}
export function defaultTmpAssessment(participantId, competencyId, questionId, observerId) {
  return {
    participantId,
    competencyExerciseId: competencyId,
    questionId,
    observerTeamMemberId: observerId,
    selectedValue: null,
    selectedCuesIds: []
  }
}

export default {
  generateOrUpdateCueAreas,
  defaultAssessment
}
